module.exports = __webpack_public_path__ + "img/supplier-logo.dffde926.svg";